<template>
  <div class="protocol">
    <header>
      <h1 class="title">服务协议</h1>
    </header>
    <main>
      <p>
        尊敬的用户(下称“您”或“用户”》，欢迎您与广州酷思纬哲网络科技有限公司、广州唯库网络科技有限公司(下称我方”或“我们”) 共同签署本《服务协议》（下称“本协议”）并成为我方互联网平台用户。
        以下各条款标题仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，建议您仔细阅读各条款具体表述。
      </p>
      <p>
        您在申请注册、登录、使用等流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。如您对协议有任何疑问，可向我方客服咨询。
        当您点击同意本协议之后，即表示您已充分阅读、理解并接受本协议的全部内容，并与我方达成一致，成为我方“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册、登录、使用等程序。
        如果您未申请注册流程，或者在本协议生效前已成为我方的注册用户，则您通过访问和/或使用我方，即视为您表示同意接受本协议的全部内容，否则请您不要访问或使用我方。
      </p>
      <h4>第一条【定义】</h4>
      <p>
        1.1
        我方互联网平台：指有讲课堂APP、有讲课堂网站（http://www.yojiang.cn）、唯库公众号及其他由我方经营或授权或被授权使用的互联网平台。
      </p>
      <p>
        1.2
        我方服务：我方基于互联网，以包含我方网站、客户端等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。
      </p>
      <p>
        1.3
        我方规则：包括在所有我方内已经发布及后续发布的全部规则、解读、公告等内容以及各平台在频道、活动页面、帮助中心等发布的各类规则、实施细则、产品说明、公告等。
      </p>
      <h4>第二条【协议范围】</h4>
      <p>
        2.1
        不可分割条款：由于互联网行业高速发展，您与我方签署的本协议列明的条款并不能完整罗列并覆盖您与我方所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，我方公示的相关声明及政策、我方规则和协议均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用我方服务，视为您同意上述补充协议。
      </p>
      <h4>第三条【账户注册与使用】</h4>
      <p>
        3.1
        用户资格：您确认，在您开始使用/注册程序使用我方服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
        特别地，如果您是未成年人，请在您的监护人的同意和指导下访问和/或使用我方。
      </p>
      <p>
        3.2
        账户说明：当您按照注册页面提示填写信息或以其他第三方平台账户登录，阅读并同意本协议且完成全部注册或登录程序后，您可获得我方账户并成为我方用户。
        您有权使用您设置或确认的我方会员名、邮箱、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录我方。
        由于用户账户关联用户信息，仅当有法律明文规定、司法裁定或经我方同意，并符合我方规则规定的用户账户转让流程的情况下，您才可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则由此产生的一切责任均由您承担。
        为使您更好地使用我方的各项服务，我方建议您按照我方要求及相关法律规定完成实名认证。
      </p>
      <p>3.3 用户信息管理</p>
      <p>
        3.3.1 真实合法：
        在使用我方服务时，您应当按我方页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便我方在必要时与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。
        您所设置的账户名不得违反国家法律法规及我方规则关于账户名的管理规定，否则我方可对您的账户名进行暂停使用或注销等处理，并向主管机关报告。
        您理解并承诺，您的账户名称、头像和简介等注册信息中不得出现违法和不良信息，没有冒用、关联机构或社会名人，您在账户注册过程中需遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。
        您同意并授权，为了更好地为您提供服务以及确保您的账户安全，我方可以根据您提供的手机号码、身份证号码等信息，向全国公民身份号码查询服务中心、电信运营商、金融服务机构等可靠单位发起用户身份真实性、用户征信记录、用户手机号码有效性状态等情况的查询。
      </p>
      <p>
        3.3.2 更新维护：
        您应当及时更新您提供的信息，在法律有明确规定要求我方对部分用户的信息进行核实的情况下，我方将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整的信息。
        如我方按您最后一次提供的信息与您联系未果、您未按照我方的要求及时提供信息、您提供的信息存在明显不实的，您将承担因此对您自身、他人及我方造成的全部损失与不利后果。
      </p>
      <p>
        3.4 账户安全规范：
        您的账户为您自行设置并由您保管。建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开我方。
        账户因您主动泄露或遭受他人攻击、诈骗等行为导致的损失及后果，均由您自行承担。
        您的账户只限您本人使用，不得出借或分享他人使用。当您的账户遭到未经授权的使用时，您应当立即通知我方，否则未经授权的使用行为均视为您本人的行为，您将自行承担所有由此导致的损失及后果。
        除我方存在过错外，您应对您账户项下的所有行为结果（包括在线签署各类协议、发布信息、发表言论、购买商品及服务及披露信息等）负责。
        如发现任何未经授权使用您账户登录我方或其他可能导致您账户遭窃、遗失的情况，建议您立即通知我方。您理解我方对您的任何请求采取行动均需要合理时间，除我方存在过错外，我方对在采取行动前已经产生的后果不承担任何责任。
      </p>
      <h4>第四条【我方服务及规范】</h4>
      <p>4.1 服务内容及说明</p>
      <p>4.1.1 我方向您提供包括以下服务：</p>
      <p>1) 提供互联网知识服务；</p>
      <p>2) 提供人工社群在线服务；</p>
      <p>3）我方提供的其他技术和/或服务（下称“其他技术和服务”）。</p>
      <p>（以上服务统称为“我方服务”）。</p>
      <p>4.1.2 我方向您提供的服务说明如下：</p>
      <p>
        1)
        您在购买我方课程并支付款项成功之日起，可以享有相应课程产品的权益。您有权知晓课程内容、课程安排、学习计划等相关信息，并阅读相关学习资料。
      </p>
      <p>
        2）购买成功后，如果课程为训练营课程，则学习模式为社群模式。训练营课程为线上内容有偿服务，附赠微信社群服务（社群服务内容以实际提供为准）。
      </p>
      <p>3）以下是您需要重点了解的我方的退款规则：</p>
      <p>
        a）因我方提供的课程为线上内容服务，基于在线内容的特殊性和产品的整体性，您购买的非训练营课程，一经购买，非因我方原因违约，我方恕不接受任何退款申请。
      </p>
      <p>
        b）如您购买的是训练营课程，在购买之日起七日内(含第七日)，未开始学习训练营课程并且未进群享受微信社群服务，您可以无理由向我方申请退款。在购买之日起七日内（含第七日），开始学习训练营课程或进群享受微信社群服务，因您的原因申请退款的，我方将扣除您已支付课程价款的20%作为您申请退款的违约金，并根据您提出申请时的课程更新进度计算比例结算退款金额。如因我方原因导致课程无法开展的，我方承诺100%退款给您。（训练营正式课程开始更新即表示您已开始学习训练营课程）
      </p>
      <p>
        c）如您购买的是训练营课程，在购买之日起七日后，开营前因您的原因申请退款的，我方同意退回您已支付课程价款的80%，另外20%作为您申请退款的违约金。如您购买的是训练营课程，且您在开营后或者开营前您已开始学习训练营课程，因您的原因申请退款的，我方将扣除您已支付课程价款的20%作为您申请退款的违约金，并根据您提出申请时的课程更新进度计算比例结算退款金额。如因我方原因导致课程无法开展的，我方承诺100%退款给您。
      </p>
      <p>
        d）如您购买的训练营课程有附赠的产品（例如奖品、赠送的课程），您在申请退款时，需先扣除附赠产品的相应价值。附赠产品的相应价值由我方确定，您对此无异议。
      </p>
      <p>
        e）如您退款时已经收到我方开具的发票，应先向我方退回发票；如您未退回已开具发票，我方有权从您申请的退款中扣除发票额相应的税费。
      </p>
      <p>
        f）如您申请退款的，我方在与您结算退款金额时均需扣除因您方支付行为产生的手续费。也特别提醒您，如您使用花呗分期付款，将令我方产生付款金额4.5%的手续费（这一比例根据相关规定/约定调整），将需要从您的退款金额中扣除。
      </p>
      <p>
        g）此外，您需清楚，您一旦退款，将无法回看课程。请您申请退款时，务必慎重。
      </p>
      <p>
        4）您购买训练营课程时，我方提供的排课安排仅为暂定排课，如需调整排课安排，我方会尽快告知您。因不可抗力及其他特殊情况导致您购买的课程无法按照既定时间进行的，我方应及时告知您，并为您重新安排培训时间，在该等情况下，我方无需向您承担任何责任。如因我方排课时间改变与您的时间冲突，您可以向我方申请调整上课时间或延期培训。以下是您需要重点了解的我方的训练营课程延期培训规则：
      </p>
      <p>
        a）您需要通过邮件形式向我方客服申请延期培训，客服邮箱为：【hezhihao@yojiang.cn】。您的延期申请能否被我方接受，视乎您申请理由的合理性及我方相关课程的整体培训安排等情况由我方决定。
      </p>
      <p>b) 若您申请延期，只能申请顺延延期。</p>
      <p>
        c）您最多申请一次延期培训，超过一次的，我方有权拒绝，在该等情况下，如您未能按期参加培训的，视为您已经完成该门课程，您不能申请退款。
      </p>
      <p>
        d）您在开营后的前三日（含第三日）以内申请延期培训的，我方不收取任何延期培训的费用；如您在开营后第四日（含第四日）至第七日（含第七日）内向我方申请延期培训，需额外补交该课程全部费用的10%作为我方的延期服务费用。如您未在前述期间内申请延期培训且未按期参加培训的，视为您已完成该门课程，您不能申请退款。
      </p>
      <p>
        5）您在参加训练营课程的过程中应严格遵守我方的教学纪律及其他相关制度要求，在学习过程及与他人过论中应遵守法律法规及网络道德，如因您个人行为影响或扰乱课程培训进程，我方有权视情况对您采取警告或停止为您提供服务，若停止为您提供服务，您将无权继续参与该课程的剩余培训，且我方已收取的课程费用无需向您退还。
      </p>
      <p>
        6)
        根据法律规定因您购买课程、接受服务而产生的税费，由客户自付。您为实现课程购买和听课所必需的一切硬件、软件、服务及其它方面的费用，亦有客户自行承担。如您购买的是非训练营课程，您可以在支付课程费用成功后三十天内向我方申请开具发票；如您购买的是训练营课程，您可以在课程结束后三十天内向我方申请开具发票。超过上述期限的，我方有权拒绝您开具发票的申请。
      </p>
      <p>4.2服务规范</p>
      <p>
        4.2.1
        我方有权向您公告（包括弹出页面、平台公告、站内消息等方式）以修改、替换、升级与我方服务相关的任何软件。如果您不同意或者不接受我方服务相关软件的修改、替换、升级，请直接拒绝、停止、取消，否则视为您同意并接受我方相关软件的修改、替代、升级，同时该同意并接受的行为仍受本协议约束。
      </p>
      <p>
        4.2.2
        您理解并认可，您使用我方或我方账户所获得的使用记录、订阅、收藏、积分、经验值、成长值、等级、身份标识、赠券、虚拟积分商品、虚拟兑换商品、虚拟赠品、下载等衍生物，您确认对其不享有所有权（除非我方另有公告说明），我方许可您按照我方规则进行使用，我方对上述衍生物不承担任何赔偿责任。
      </p>
      <p>
        4.2.3
        您同意并保证，不得利用我方服务或其衍生物（包括账户、积分、等级、积分商品、活动赠品、下载等服务）进行倒卖、转手、置换、抵押有价交易等方式非法牟利。您不会利用我方服务或其衍生物侵犯他人的合法权益，禁止通过网络漏洞、恶意软件或其他非法手段窃取、盗用他人的账户、积分、积分商品等。
      </p>
      <p>
        4.2.4
        您理解并认可，如果您通过第三方支付工具在我方账户支付或充值后可能产生的任何商业风险（包括不法分子利用您账户或银行卡等有价卡等进行违法活动），该等风险均有可能给您造成相应的经济损失，我方在充分履行其在本协议项下义务和符合法律规定的前提下，不对您的前述风险和损失承担任何责任。
      </p>
      <p>
        4.2.5
        为方便您使用我方和我方关联公司的其他相关服务，您授权我方将您在账户注册和使用我方服务过程中提供、形成的信息传递给我方关联公司等其他相关服务提供者，或从我方关联公司等其他相关服务提供者获取您在注册、使用相关服务期间提供、形成的信息。
        您理解并知晓在使用我方服务时，所接触的内容和信息来源广泛，我方无法对该内容和信息的准确性、真实性、可用性、安全性、完整性和正当性负责。您理解并认可您可能会接触到不正确的、令人不快的、不适当的或令人厌恶的内容和信息，您不会以此追究我方的相关责任。我方不对用户在我方上传、发布或传输的任何内容和信息背书、推荐或表达观点，也不对任何内容和信息的错误、瑕疵及产生的损失或损害承担任何责任，您对内容和信息的任何使用需自行承担相关的风险。
      </p>
      <p>
        4.2.6
        您同意我方在提供服务的过程中以各种方式投放商业性广告或其他任何类型的商业信息（包括在我方的任何位置上投放广告，在您上传、传播的内容中投放广告），您同意接受我方通过电子邮件、站内短信、手机短信、网站公告或其他方式向您发送促销或其他相关商业信息。
      </p>
      <p>
        4.2.7
        您同意在使用我方服务过程中，遵守以下法律法规：《中华人民共和国民法典》、《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国反不正当竞争法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《信息网络传播权保护条例》等有关计算机及互联网规定的法律、法规。在任何情况下，我方一旦合理地认为您的行为可能违反上述法律、法规，可以在任何时候，不经事先通知终止向您提供服务。
      </p>
      <p>4.3 禁止的内容</p>
      <p>
        您理解并保证您在我方上传、发布或传输的内容（包括您的账户名称等信息）不含有以下内容：
      </p>
      <p>1）反对宪法确定的基本原则的；</p>
      <p>2）危害国家统一、主权和领土完整的；</p>
      <p>3）泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；</p>
      <p>4）煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；</p>
      <p>5）宣扬邪教、迷信的；</p>
      <p>6）扰乱社会秩序，破坏社会稳定的；</p>
      <p>7）诱导未成年人违法犯罪和渲染暴力、色情、赌博、恐怖活动的；</p>
      <p>8）侮辱或者诽谤他人，侵害公民个人隐私等他人合法权益的；</p>
      <p>9）危害社会公德，损害民族优秀文化传统的；</p>
      <p>
        10）有关法律、行政法规和国家规定禁止的其他内容。如果您上传、发布或传输的内容含有以上违反法律法规的信息或内容的，或者侵犯任何第三方的合法权益，您将直接承担以上导致的一切不利后果。如因此给我方造成不利后果的，您应负责消除影响，并且赔偿我方因此导致的一切损失，包括且不限于财产损害赔偿、名誉损害赔偿、律师费、交通费等因维权而产生的合理费用。
      </p>
      <p>4.4 禁止的行为</p>
      <p>
        您理解并保证不就我方服务进行下列的禁止的行为，也不允许任何人利用您的账户进行下列行为：
      </p>
      <p>
        1)
        在注册账户时，或使用我方服务时，冒充他人，或您讹称与任何人或实体有联系（包括设置失实的账户名称或接入另一用户的账户）；
      </p>
      <p>2) 伪造标题或以其他方式操控内容，使他人误认为该内容为我方所传输；</p>
      <p>
        3)
        将无权传输的内容（例如内部资料、机密资料）进行上传、发布、发送电子邮件或以其他方式传输；
      </p>
      <p>
        4)
        发送任何未获邀约或未经授权的垃圾电邮、广告或宣传资料，或任何其他商业通讯；
      </p>
      <p>
        5) 未经我方明确许可，使用我方服务用于任何商业用途或为任何第三方的利益；
      </p>
      <p>6) 跟踪或以其他方式骚扰他人；</p>
      <p>
        7)
        参与任何非法或有可能非法（由我方判断）的活动或交易，包括传授犯罪方法、出售任何非法药物、洗钱活动、诈骗等；
      </p>
      <p>8) 赌博、提供赌博数据或透过任何方法诱使他人参与赌博活动；</p>
      <p>
        9)
        使用或利用我方知识产权（包括我们的商标、品牌、标志、任何其他专有数据或任何网页的布局或设计），或在其他方面侵犯我方任何知识产权（包括试图对我方客户端或所使用的软件进行逆向工程）；
      </p>
      <p>
        10)
        通过使用任何自动化程序、软件、引擎、网络爬虫、网页分析工具、数据挖掘工具或类似工具，接入我方服务、收集或处理通过我方服务所提供的内容；
      </p>
      <p>
        11) 参与任何“框架”、“镜像”或其他技术，目的是模仿我方服务的外观和功能；
      </p>
      <p>12) 干预或试图干预任何用户或任何其他方接入我方服务；</p>
      <p>
        13)
        故意散播病毒、网络蠕虫、特洛伊木马病毒、已损毁的档案或其他恶意代码或项目；
      </p>
      <p>14) 未经他人明确同意，分享或发布该等人士可识别个人身份的资料；</p>
      <p>
        15)
        探究或测试我方服务、系统或其他用户的系统是否容易入侵攻击，或在其他方面规避（或试图规避）我方服务、系统或其他用户的系统的任何安全功能；
      </p>
      <p>
        16)
        对我方服务所用的软件进行解编、反向编译或逆向工程，或试图作出上述事项；
      </p>
      <p>
        17)
        为破坏或滥用的目的开设多个账户，或恶意上传重复的、无效的大容量数据和信息；
      </p>
      <p>
        18)
        故意或非故意违反任何相关的中国法律、法规、规章、条例等其他具有法律效力的规范。
      </p>
      <h4>第五条【隐私政策】</h4>
      <p>
        如果您不同意本隐私权政策任何内容，您应立即停止使用我方服务。当您使用我方提供的任一服务时，即表示您已同意我们按照本隐私权政策来合法使用和保护您的个人信息。
      </p>
      <p>5.1 适用范围</p>
      <p>
        本隐私权政策适用于我方提供的所有服务，您访问我方及/或登录相关客户端使用我方提供的服务，均适用本隐私权政策。
        需要特别说明的是，本隐私权政策不适用于其他第三方向您提供的服务，例如我方上的第三方依托我方向您提供服务时，您向第三方提供的个人信息不适用于本隐私权政策，我方对任何第三方使用由您提供的信息不承担任何责任。
        我方将基于合法、合理和诚实信用的法定原则妥善处理或使用您的个人信息。
      </p>
      <p>5.2 我们如何收集信息</p>
      <p>
        我们收集信息是为了向您提供更好、更优、更个性化的服务，我们收集信息的方式如下：
      </p>
      <p>1) 您向我们提供的信息。</p>
      <p>
        当您注册我方账户及您在使用我方提供的相关服务时填写及/或提交的信息，包括您的姓名、性别、出生年月日、身份证号码、电话号码、电子邮箱、地址、兴趣爱好、支付账户及相关附加信息（如您所在的省份和城市、邮政编码）。
      </p>
      <p>2) 在您使用服务过程中收集的信息。</p>
      <p>
        为了提供并优化您需要的服务，我们会收集您使用服务的相关信息，这类信息包括：
        在您使用我方服务，或访问我方网页时，我方自动接收并记录的您的浏览器和计算机上的信息，包括您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录数据；如您下载或使用我方或其关联公司客户端软件，或访问移动网页使用我方服务时，我方可能会读取与您位置和移动设备相关的信息，包括设备型号、设备识别码、操作系统、分辨率、电信运营商。
        您通过我方的内容上传服务所上传的内容所包含的信息，例如拍摄或上传的共享照片或录像的日期、时间或地点。
        除上述信息外，我们还可能为了提供服务及改进服务质量的合理需要而收集您的其他信息，包括您与我们的客户服务团队联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我方的关联方、我方合作伙伴之间互动时我们收集的相关信息。与此同时，为提高您使用我方提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会通过了解一些您的网络使用习惯、您常用的软件信息手段来判断您账户的风险，并可能会记录一些我们认为有风险的URL。
      </p>
      <p>3) 来自第三方的信息。</p>
      <p>
        为了给您提供更好、更优、更加个性化的服务，或共同为您提供服务，或为了预防互联网欺诈的目的，我方的关联方、合作伙伴会依据法律的规定或与您的约定或征得您同意的前提下，向我方分享您的个人信息。
      </p>
      <p>您了解并同意，以下信息不适用本隐私权政策：</p>
      <p>a) 您在使用我方提供的搜索服务时输入的关键字信息；</p>
      <p>b) 违反法律规定或违反我方规则行为及我方已对您采取的措施；</p>
      <p>c) 应法律法规要求需披露的个人信息；</p>
      <p>d) 紧急情况下，为维护用户及公众的利益。</p>
      <p>5.3 我们如何使用信息</p>
      <p>
        因收集您的信息是为了向您提供服务及提升服务质量的目的，为了实现这一目的，我们会把您的信息用于下列用途：
      </p>
      <p>1) 向您提供您使用的各项服务，并设计、维护、改进这些服务。</p>
      <p>
        2)
        向您推荐您可能感兴趣的内容，包括向您发出产品和服务信息，或通过系统向您展示个性化的第三方推广信息，或者在征得您同意的情况下与我方的合作伙伴共享信息以便他们向您发送有关其产品和服务的信息。
      </p>
      <p>3) 向您提供与您更加相关的广告以替代普遍投放的广告。</p>
      <p>
        4)
        我们可能使用您的个人信息以预防、发现、调查欺诈、危害安全、非法或违反与我们或其关联方协议、政策或规则的行为，以保护您、其他我们用户，或我们或其关联方的合法权益。
      </p>
      <p>
        5)
        我们可能会将来自某项服务的个人信息与来自其他服务的信息结合起来，用于为了给您提供更加个性化的服务使用，例如让您拥有更广泛的社交圈的需要而使用、共享或披露。
      </p>
      <p>6) 让您参与有关我们产品和服务的调查，或者促销及抽奖活动。</p>
      <p>7) 经您许可的其他用途。</p>
      <p>5.4 我们如何共享信息</p>
      <p>
        我们对您的信息承担保密义务，不会出售或出租您的任何信息，我们会在下列情况下才将您的信息与第三方共享：
      </p>
      <p>1) 事先获得您的同意或授权。</p>
      <p>2) 根据法律法规的规定或行政或司法机构的要求。</p>
      <p>3) 向我方的关联方分享您的个人信息。</p>
      <p>
        4)
        向可信赖的合作伙伴提供您的个人信息，让他们根据我们的指示并遵循我们的隐私权政策以及其他任何相应的保密和安全措施来为我们处理这些信息。
      </p>
      <p>
        5)
        如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。
      </p>
      <p>
        6)
        如您出现违反中国有关法律、法规或者我方相关协议或相关规则的情况，需要向第三方披露。
      </p>
      <p>7) 为维护我方及其关联方或用户的合法权益。</p>
      <p>5.5 Cookie的使用</p>
      <p>
        为使您获得更轻松的访问体验，您访问我方或使用我方提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie，Flash
        Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。
      </p>
      <p>
        请您理解，我们的某些服务只能通过使用“Cookie”才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝我方的Cookie，但这一举动在某些情况下可能会影响您安全访问我方相关网站和使用我方提供的服务。
      </p>
      <p>5.6 信息存储</p>
      <p>
        我方收集的有关您的信息和资料将保存在我方及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或我方收集信息和资料所在地并在该地被访问、存储和展示。
      </p>
      <p>5.7 您的个人信息保护</p>
      <p>
        为保障您的信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括SSL、信息加密存储、数据中心的访问控制。我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况措施。我方会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我方将尽力做到使您的信息不被泄漏、毁损或丢失。
        您的账户均有安全保护功能，请妥善保管您的账户及密码信息。我方将通过向其它服务器备份、对用户密码进行加密安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。
      </p>
      <p>5.8 用户申诉渠道及反馈方式</p>
      <p>
        如您对隐私政策的执行或使用我们的产品、技术及/或服务时遇到的与隐私保护相关的事宜有任何问题（包括问题咨询、投诉），可随时跟我方的客服反馈您的意见或者建议。
      </p>
      <h4>第六条【第三方链接】</h4>
      <p>
        我方服务可能会包含与其他网站或资源的链接。我方对于前述网站或资源的内容、隐私政策和活动，无权控制、审查或修改，因而也不承担任何责任。我方建议您在离开我方，访问其他网站或资源前仔细阅读其服务条款和隐私政策。
      </p>
      <h4>第七条【知识产权】</h4>
      <p>7.1 知识产权归属</p>
      <p>
        除非另有约定或我方另行声明，我方内的所有内容（用户依法享有版权的内容除外）、技术、软件、程序、数据及其他信息（包括文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有知识产权（包括版权、商标权、专利权、商业秘密等）及相关权利，均归我方或我方关联公司所有。未经我方许可，任何人不得擅自使用（包括复制、翻录、传播、展示、镜像、上载、下载、修改、出租）。
        我方的Logo等文字、图形及其组合，以及我方的其他标识、徵记、产品和服务名称均为我方或我方关联公司在中国或其它国家的商标，未经我方书面授权，任何人不得以任何方式展示、使用或作其他处理，也不得向他人表明您有权展示、使用或作其他处理。
        我方对我方专有内容、原创内容和其他通过授权取得的独占或独家内容享有完全知识产权。未经我方许可，任何单位和个人不得私自转载、传播和提供观看服务或者有其他侵犯我方知识产权的行为，否则将承担所有相关的法律责任。
        如您侵犯我方知识产权，包括但不限于复制、翻录、传播我方的课程内容的，我方有权立即终止本协议，拒绝向您提供课程服务，不退还您已支付的课程费用，并要求您承担相应的侵权及赔偿责任。
      </p>
      <p>7.2 用户知识分享</p>
      <p>
        为了促进知识的分享和传播，用户在训练营学习期间发表的全部内容（包括但不仅限于留言、案例、学习心得、评论、笔记、毕业设计），授予我方及其关联公司免费的、不可撤销的、可转授权的、非独家使用许可，我们有权将该内容用于我方及关联方各种形态的产品和服务上。
        用户在我方平台上传或发表的图片、文章或讨论区发言内容，应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于知识产权侵权的异议，我方有权根据实际情况删除相关的内容，且有权追究用户的法律责任。给我方或任何第三方造成损失的，用户应负责相应的赔偿责任。
      </p>
      <p>7.3 侵权投诉</p>
      <p>
        7.3.1
        任何第三方认为，用户利用我方侵害其民事权益或实施侵权行为的，被侵权人有权书面通知我方采取删除、屏蔽、断开链接等必要措施。
      </p>
      <p>
        7.3.2
        根据《信息网络传播权保护条例》的规定，任何第三方认为，我方所涉及的作品、表演、录音录像制品，侵犯自己的合法权益的，可以向我方提交书面通知，要求我方删除该侵权作品，或者断开链接。通知书应当包含下列内容：权利人的姓名（名称）、联系方式和地址；要求删除或者断开链接的侵权作品、表演、录音录像制品的名称和网络地址；权利人的有效权利证明材料。权利人应当对通知书的真实性负责，如果侵权投诉不实，则需承担相应的法律责任。
      </p>
      <p>
        7.3.3
        侵权投诉必须包含下述信息：被侵权人的有效权利证明材料，或被侵权作品的原始链接及其它证明材料；侵权信息或作品在我方上的具体名称及链接；侵权投诉人的联络方式，以便我方及时与您取得联系，包括电子邮件地址、电话号码或手机等；投诉内容须纳入以下声明：“本人本着诚信原则，有证据认为该对象侵害本人的合法权益。本人承诺全部投诉信息真实、准确，自愿承担一切后果。”；本人亲笔签字并注明日期，如代理他人投诉的，必须出具授权人签字的授权书。
      </p>
      <h4>第八条【社群公约】</h4>
      <p>8.1训练营社群规则</p>
      <p>为了给用户营造一个积极向上、健康、高效、温暖的社群氛围，您在我方互联网平台所属的社群学习时须遵守如下训练营社群规则：</p>
      <p>1）不得违反国家法律法规禁止性规定；</p>
      <p>2）不得讨论政治性等敏感话题；</p>
      <p>3）不得讨论封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的内容；</p>
      <p>4）不得侮辱或者诽谤他人、侵害公民个人隐私等他人合法权益；</p>
      <p>5）对影响社会稳定、破坏公共秩序的虚假消息，不转发，不扩散，并及时向社群内我方管理人员（以下称“班委”）反映；</p>
      <p>6）未经班委允许，不得私自将我方平台学习资料（包括课程、加餐资料、答疑资料等）传播给他人；</p>
      <p>7）未经班委允许，不得私加学习群内学员或邀请他人进群；</p>
      <p>8）未经班委允许，不得私自进行引流行为，如推销任何平台或产品或发布与训练营无关的信息，包括广告、链接、小程序、外部群、二维码等，或私自对社群内成员进行建群、拉群等行为；</p>
      <p>9）未与班委进行任何沟通，不得任意在群内发泄个人情绪，扰乱课堂秩序，影响其他学员；</p>
      <p>10）其他影响课堂秩序、影响其他学员或我方正常运营管理的行为。</p>
      <p>11）其他违反法律法规或损害社会公共利益的行为。</p>
      <p>如您违反以上训练营社群规则，班委将有权将您暂时/永久移出训练营社群，情节严重者，我方有权立即终止向您提供课程服务，相关课程费用不予退还，并依法追究您的法律责任。</p>
      <p>8.2知识产权说明</p>
      <p>请您自觉遵守本协议第七条【知识产权】的规定，如您在接受我方服务过程中发现违反第七条的情况，可第一时间联系我们，您的每一个微小动作，都会化为保护知识产权的一份力量。凡向我方提供有价值线索，协助我方取证者，我方将予以奖励并依法保护举报人的个人信息及隐私安全。</p>
      <p>以上为有讲课堂训练营社群公约，希望广大用户自觉遵守，共同营造良好的学习环境。</p>
      <h4>第九条【协议的变更】</h4>
      <p>
        我方可根据国家法律法规变化及我方服务变化的需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过本协议第九条约定的方式通知您。
      </p>
      <p>
        如您对变更事项不同意的，您应当于变更事项确定的生效之日起停止使用我方服务；如您在变更事项生效后仍继续使用我方服务，则视为您同意已生效的变更事项。
      </p>
      <h4>第十条【通知】</h4>
      <p>您同意我方以以下合理的方式向您送达各类通知：</p>
      <p>（一）在我方平台或其他公开途径公示的通知等内容；</p>
      <p>（二）站内消息、弹出消息、客户端推送的消息；</p>
      <p>（三）根据您预留于我方的联系方式发出的电子邮件、手机短信、函件等；</p>
      <p>（四）其他通过您的账户或联系方式向您发送的消息。</p>
      <h4>第十一条【协议/服务的终止】</h4>
      <p>11.1 终止的情形</p>
      <p>您有权通过以下任一方式终止本协议：</p>
      <p>
        （一）在满足我方公示的账户注销等清理条件时您通过网站注销您的账户的；
      </p>
      <p>（二）变更事项生效前您停止使用并明示不愿接受变更事项的；</p>
      <p>（三）您明示不愿继续使用我方服务，且符合我方终止条件的。</p>
      <p>出现以下情况时，我方可以不经您的同意，提前终止向您提供服务：</p>
      <p>
        （一）您违反本协议约定或实施本协议中的禁止行为，我方依据本协议相关条款终止本协议的；
      </p>
      <p>
        （二）您转让本人账户、盗用他人账户、发布违禁内容和信息、骗取他人财物、采取不正当手段谋利等行为，我方依据我方规则对您的账户予以查封的；
      </p>
      <p>
        （三）除上述情形外，因您多次违反我方规则相关规定且情节严重，我方依据我方规则对您的账户予以查封的；
      </p>
      <p>（四）您的账户被我方依据本协议进行注销等清理的；</p>
      <p>（五）您在我方有侵犯他人合法权益或其他严重违法违约行为的；</p>
      <p>（六）我方基于运营策略或其他单方原因，认为不适合再向您提供服务的；</p>
      <p>（七）其它根据相关法律法规我方应当终止服务的情况。</p>
      <p>11.2 协议终止后的处理</p>
      <p>
        本协议终止后，除法律有明确规定外，我方无义务向您或您指定的第三方披露您账户中的任何信息。
      </p>
      <p>本协议终止后，我方享有下列权利：</p>
      <p>
        （一）停止收集和使用您的个人信息，但可继续保存您留存于我方的其他内容和信息；
      </p>
      <p>（二）对于您过往的违约行为，我方仍可依据本协议向您追究违约责任。</p>
      <h4>第十二条【法律适用、管辖与其他】</h4>
      <p>
        本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国法律；如法律无相关规定的，参照商业惯例及/或行业惯例。
        您因使用我方服务所产生及与我方服务有关的争议，由我方与您协商解决。协商不成时，任何一方均应向中国广州仲裁委员会提起仲裁。
        本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
      </p>
      <h4>【审慎提醒】</h4>
      <p>
        如您点击或勾选“同意”，则本协议将立即生效，并构成您和广州酷思纬哲网络科技有限公司之间有约束力的法律文件。
      </p>
      <p>请您再次确认您已全部阅读并充分理解上述协议。</p>
      <p class="datetime" v-if="payTimeStr">日期：{{ payTimeStr }}</p>
    </main>
  </div>
</template>

<script>
export default {
  name: 'protocol',
  data() {
    return {
      payTime: this.$route.query.pt || '',
      payTimeStr: ''
    };
  },
  created() {
    if (this.payTime) {
      this.payTimeStr = `${this.payTime.substr(0, 4)}年${
        this.payTime.substr(4, 2)}月${
        this.payTime.substr(6, 2)}日`;
    }
  },
  methods: {

  }
};
</script>

<style lang="stylus" scoped>
.protocol {
  padding: 15px 20px;
  width: 100%;
}

.title {
  box-sizing: content-box;
  margin: 0;
  width: auto;
  font-size: 22.5pt;
  font-weight: 800;
  height: 60px;
  padding-top: 30px;
  border-bottom: 1px solid #e7e7e7;
  text-align: center;
}

.datetime {
  margin: 20px 0;
  text-align: right;
}

main {
  width: 100%;

  p {
    font-size: 16px;
    color: #191919;
    line-height: 32px;
  }

  h4 {
    padding: 30px 0 15px;
    font-size: 22px;
    font-weight: 900;
    line-height: 36px;
    color: #191919;
  }
}
</style>
